import { render, staticRenderFns } from "./TwoColumnTextModule.vue?vue&type=template&id=5ca86fd9&"
import script from "./TwoColumnTextModule.ts?vue&type=script&lang=ts&"
export * from "./TwoColumnTextModule.ts?vue&type=script&lang=ts&"
import style0 from "./TwoColumnTextModule.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports